
import React, { Component } from 'react';
import './energyLogPage.less';
import { Checkbox, Input, Select, Button } from "antd";
import PubSub from 'pubsub-js'
import { meshLog, SPGet, SPSet } from '../../../utils/spUtils';
import schedule from "../../../imgs/sidebar/schedule_click.png";
import emergency from "../../../imgs/item/emergency.png";
import normal from "../../../imgs/mesh/normal.png";
import warn from "../../../imgs/mesh/warn.png";
import btn_left from "../../../imgs/btn/btn_left.png";
import btn_right from "../../../imgs/btn/btn_right.png";
import { deviceNo } from "../../../const/infoConst";
import { searchEmergency, downEmergencyLog, downSearchPowerLog } from "../../../utils/net/netManager";
import { bigEndianToLittleEndian, trans4toString } from '../../../utils/dataUtils';
import { getDeviceInfoByMac, getNameBygroupID } from '../../../utils/deviceUtils';
import { getBleVer } from '../../../utils/meshUtils';

let m_model = 0;
let m_status = 0;
export default class EnergyLogPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: [],
            dateRange: {
                start: "2025-02-10",
                end: "2025-08-10",
            },
            mode_arr: [{ value: 0, label: 'All Test' },
            { value: 1, label: 'Manual Test' },
            { value: 2, label: 'Monthly Test' },
            { value: 3, label: 'Annual Test' }],
            result_arr: [{ value: 0, label: 'All' },
            { value: 1, label: 'Passed' },
            { value: 2, label: 'Failed' }],
            list: [],
            currentItems: [],//当前页码的数据
            currentPage: 1,//当前的页码
            totalPages: 0,//所有的页码总数
            itemsPerPage: 10,//每页展示多少数据
            failed: 0,
            passed: 0,
            group: "1",
            downloadDeviceInfo: [],
        };
    }

    componentDidMount() {
        //退出
        PubSub.unsubscribe("selectGroupCheckInfo")
        PubSub.subscribe('selectGroupCheckInfo', (msg, data) => {
            meshLog('应急日志界面', data);
            PubSub.publish("energyManagePage", data);
            let groupIDs = ""
            for (let index = 0; index < data.length; index++) {
                if (data[index].checked) {
                    groupIDs = groupIDs + data[index].id + ','
                }

            }
            meshLog('groupIDs', groupIDs);
            this.setState({
                group: groupIDs,
            })
            let downloadGroupEnergyLog = (SPGet("downloadGroupEnergyLog"));
            if (downloadGroupEnergyLog == 0) {
                this.goToPage(1)
            }
        })
        this.goToPage(1)
    }
    //获取数据库的结果
    getDefaultList() {
        let arr = [];
        arr[0] = { "id": 1, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "50%", "model": 0, "result": 0 };
        arr[1] = { "id": 2, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "100%", "model": 1, "result": 0 };
        arr[2] = { "id": 3, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "75%", "model": 2, "result": 1 };
        arr[3] = { "id": 4, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "30%", "model": 0, "result": 1 };
        arr[4] = { "id": 5, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "90%", "model": 0, "result": 1 };
        arr[5] = { "id": 6, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "60%", "model": 1, "result": 1 };
        arr[6] = { "id": 7, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "80%", "model": 1, "result": 1 };
        arr[7] = { "id": 8, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "10%", "model": 1, "result": 1 };
        arr[8] = { "id": 9, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "20%", "model": 0, "result": 1 };
        arr[9] = { "id": 10, "mac": "4325", "name": "HSE-EIA15-01S-B", "location": "13F Area / Front Desk", "ver": "V1.5.3", "battery": "5%", "model": 1, "result": 1 };
        return arr;
    }

    goToPage = async (page) => {
        meshLog('当前展示的page', page);
        const wangguan = JSON.parse(SPGet("wangguan"))
        const mac = bigEndianToLittleEndian(wangguan.macAddress)
        let token = (SPGet("token"));
        let maddr = (SPGet("email"));
        let type = 1;
        let group = this.state.group
        const result = await searchEmergency(deviceNo, maddr, token, type, mac, group)
        meshLog('resultresultresult', result);
        const { code, msg } = result;
        if (code == 0) {
            let emergencyList = msg.emergencyList
            // 计算总页数
            let itemsPerPage = this.state.itemsPerPage
            // meshLog('itemsPerPage', itemsPerPage);
            const totalPages = Math.ceil(emergencyList.length / itemsPerPage);
            // meshLog('totalPages', totalPages);
            let currentPage = page //默认显示第一个页码的数据
            let maxlength
            if (emergencyList.length > currentPage * 10) {
                maxlength = currentPage * 10
            } else {
                maxlength = emergencyList.length
            }
            // meshLog('maxlength', maxlength);
            // meshLog('currentPage', currentPage);
            let failed = 0
            let passed = 0
            for (let i = 0; i < emergencyList.length; i++) {
                if (emergencyList[i].testResult == '0') {
                    passed++
                } else {
                    failed++
                }
                const time = Number(emergencyList[i].time)
                var date = new Date(time * 1000);
                var formattedDate = date.toLocaleString();

                meshLog('formattedDate', formattedDate);
                meshLog('timetime', date);
                emergencyList[i] = {
                    'deviceMac': trans4toString(emergencyList[i].deviceMac),
                    'name': getDeviceInfoByMac(emergencyList[i].deviceMac).name,
                    'groupIDName': getNameBygroupID(getDeviceInfoByMac(emergencyList[i].deviceMac).groupID),
                    'vid': getBleVer(getDeviceInfoByMac(emergencyList[i].deviceMac).vid),
                    'power': (emergencyList[i].power),
                    'model': emergencyList[i].testMode == 0 ? "Manual Test" : (emergencyList[i].testMode == 1 ? "Monthly Test" : "Annual Test"),
                    'result': (emergencyList[i].testResult == 0 ? "Passed" : "Failed") + ' ' + new Date(emergencyList[i].time * 1000).toLocaleString(),
                    'time': new Date(emergencyList[i].time * 1000).toLocaleString(),  // 时间戳
                    'groupID': (getDeviceInfoByMac(emergencyList[i].deviceMac).groupID),
                };

            }
            const currentItems = emergencyList.slice((currentPage - 1) * 10, maxlength);
            meshLog('当前显示的数据', currentItems);
            this.setState({
                currentPage: currentPage,
                totalPages: totalPages,
                currentItems: currentItems,
                list: currentItems,
                failed: failed,
                passed: passed,
            })
        } else {

        }

    };
    // 上一页
    goToPreviousPage = () => {
        if (this.state.currentPage <= 1) {
            return
        } else {
            let currentPage = this.state.currentPage
            this.setState({
                currentPage: currentPage - 1,
            })
            this.goToPage(currentPage - 1);
        }

    };
    // 下一页
    goToNextPage = () => {
        if (this.state.currentPage >= this.state.totalPages) {
            return
        } else {
            let currentPage = this.state.currentPage
            this.setState({
                currentPage: currentPage + 1,
            })
            this.goToPage(currentPage + 1);
        }
    };

    //model选择
    handleModelChange = (value) => {
        meshLog("Model", value);
        m_model = value; //0-all 1-Manual 2-Monthly 3-Annual
        m_status = 0;
        let setArr = [];
        let count = 0;
        let arr = this.getDefaultList();
        for (let i = 0; i < arr.length; i++) {
            if (m_model == 0) {
                setArr[count] = arr[i];
                count++;
            } else if (m_model == 1) {
                if (arr[i].model == 0) {
                    setArr[count] = arr[i];
                    count++;
                }
            } else if (m_model == 2) {
                if (arr[i].model == 1) {
                    setArr[count] = arr[i];
                    count++;
                }
            } else if (m_model == 3) {
                if (arr[i].model == 2) {
                    setArr[count] = arr[i];
                    count++;
                }
            }
        }
        this.setState({ list: setArr });
    }
    //result选择
    handleResultChange = (value) => {
        meshLog("Result", value);
        m_status = value; //0-All 1-Passed 2-Failed
        m_model = 0;
        let setArr = [];
        let count = 0;
        let arr = this.getDefaultList();
        for (let i = 0; i < arr.length; i++) {
            if (m_status == 0) {
                setArr[count] = arr[i];
                count++;
            } else if (m_status == 1) {
                if (arr[i].result == 1) {
                    setArr[count] = arr[i];
                    count++;
                }
            } else if (m_status == 2) {
                if (arr[i].result == 0) {
                    setArr[count] = arr[i];
                    count++;
                }
            }
        }
        this.setState({ list: setArr });
    }

    setInputValue = (value) => {
    }
    checkDevicesInfo = (key, list, value) => {
        let downloadDeviceInfo = this.state.downloadDeviceInfo
        let currentPage = this.state.currentPage
        let index = key + (currentPage - 1) * 10
        meshLog('list', list);
        meshLog('key', key);
        meshLog('value', value);
        meshLog('downloadDeviceInfo[index] == !', downloadDeviceInfo[index]);
        if (downloadDeviceInfo[index] == undefined || downloadDeviceInfo[index] == '') {
            downloadDeviceInfo[index] = list
        } else {
            downloadDeviceInfo[index] = ''
        }

        this.setState({
            downloadDeviceInfo: downloadDeviceInfo,
        })
        //这边要区分是下载哪个设备 0代表是EnergyLog，1代表是计量设备统计
        SPSet("downloadGroupEnergyLog", 0)
        //发送到下载界面，需要判断两个，一个是undefined还有一个是'' 的对象
        PubSub.publish("downloadGroupEnergyLog", downloadDeviceInfo);
        meshLog('downloadDeviceInfo', downloadDeviceInfo);
    }

    downloadGroupEnergyLog = async () => {
        let maddr = (SPGet("email"));
        let MeshName = (SPGet("SelectMeshName"));
        const result = this.state.downloadDeviceInfo
        meshLog('MeshName', MeshName);
        if (result == '') {
            meshLog('result空', result);
        } else {
            meshLog('result有值', result);
            try {
                let results = await downEmergencyLog(result, maddr, MeshName)
                meshLog('resultsresults', results);
                if (results.code == 0) {
                    const fileUrl = results.msg.url;
                    // 直接在新窗口/标签页打开文件链接
                    // 让浏览器处理下载
                    window.open(fileUrl, '_blank');
                } else {
                    alert("请输入正确的参数")
                }
            } catch (error) {
                console.error('下载错误:', error);
                alert("下载失败: " + error.message);
            }
        }
    }



    render() {
        const { dateRange } = this.state;
        return (
            <div className="energyLog_container">
                {/* 标题行 */}
                <div className="energ_title">
                    <span className='title'>Emergency Log</span>
                    <div className="energ_time">
                        <div className="item2_title">
                            <img src={schedule} />
                            <span>Select Date</span>
                        </div>
                        {/* 选择时间 */}
                        <div className="date-range-group">
                            <input
                                type="date"
                                name="start"
                                value={dateRange.start}
                                onChange={(e) => this.setInputValue(e.target.value)} // 必须添加此处理器
                            />
                            <span className="range-separator">~</span>
                            <input
                                type="date"
                                name="end"
                                value={dateRange.end}
                                onChange={(e) => this.setInputValue(e.target.value)} // 必须添加此处理器
                            />
                        </div>
                        {/* //添加下载按钮 */}

                        {/* 导出按钮 */}
                        <Button className='enportBtn' onClick={() => { this.downloadGroupEnergyLog() }} >Export Report</Button>



                    </div>
                </div>
                {/* 归类 */}
                <div className='logTopInfo'>
                    <div className='passBg'>
                        <img className='p_img1' src={emergency} />
                        <img className='p_img2' src={normal} />
                        <span className='p_1'>Passed</span>
                        <span className='p_2'>{this.state.passed}</span>
                        <span className='p_3'>pcs</span>
                    </div>
                    <div className='failBg'>
                        <img className='f_img1' src={emergency} />
                        <img className='f_img2' src={warn} />
                        <span className='f_1'>Failed</span>
                        <span className='f_2'>{this.state.failed}</span>
                        <span className='f_3'>pcs</span>
                    </div>
                    <div className='searchBg'>
                        <Input className='input' placeholder="Please enter the query content" />
                        <span>Query</span>
                    </div>
                </div>

                {/* 列表标题 */}
                <div className='list_title'>
                    <input className="t_checkbox" type='checkbox' name='group' value='' />
                    <span className='t_1'>No.</span>
                    <span className='t_2'>MAC</span>
                    <span className='t_3'>Device Name</span>
                    <span className='t_4'>Device Location</span>
                    <span className='t_5'>Version Update </span>
                    <span className='t_6'>Battery Power</span>
                    <Select
                        className="t_set_down1"
                        defaultValue={this.state.mode_arr[0]}
                        onChange={this.handleModelChange}
                        options={this.state.mode_arr} />
                    <Select
                        className="t_set_down2"
                        defaultValue={this.state.result_arr[0]}
                        onChange={this.handleResultChange}
                        options={this.state.result_arr} />
                </div>
                {/* 列表 */}
                <div className="log_list">
                    {this.state.list.map((list, key) => (
                        <div key={key} className="list_item">
                            <input className="l_checkbox" type='checkbox' name='group' value='' onChange={(e) => { this.checkDevicesInfo(key, list, e.target.value) }} />
                            <span className='l_1'>{key + 1}</span>
                            <span className='l_2'>{list.deviceMac}</span>
                            <span className='l_3'>{list.name}</span>
                            <span className='l_4'>{list.groupIDName}</span>
                            <span className='l_5'>{list.vid}</span>
                            <span className='l_6'>{list.power}%</span>
                            <span className='l_7'>{list.model}</span>
                            <img className='l_state' src={list.result} />
                            <span className='l_8'>{list.result}</span>

                        </div>
                    ))}
                </div>

                {/* 底部按钮 */}
                <div className="energyLog_footer">
                    <span className='info'>Total {this.state.totalPages} Pages</span>
                    <img className='btn_left' onClick={() => { this.goToPreviousPage() }} src={btn_left} />
                    <span className='page'>{this.state.currentPage}</span>
                    <img className='btn_right' onClick={() => { this.goToNextPage() }} src={btn_right} />
                </div>


            </div>

        );
    }
}
